module.exports = __webpack_public_path__ + "static/media/welcome.79597813.jpg";